/**
 * Кастомный календарь
 *
 * @param {Date} minDate минимальная дата
 * @param {Date} maxDate максимальная дата
 * @param {string} ajaxUrl Url для получения данных по ajax
 * @param {string} wrapperClass Класс элемента в который будет вставлен html
 * @lang  {string} код языка
 */
$.fn.customCalendar = function (minDate, maxDate, ajaxUrl, wrapperClass, lang) {
    if (typeof $.fn.datepicker === 'undefined') {
        console.error('customCalendar: datepicker is not defined!');
        return;
    }

    let $self = $(this);
    const defaultParams = {
        'AJAX': true,
    };

    const $wrapper = $(`.${wrapperClass}`);
    const $loader = $('.js-loader-wrapper');

    /**
     * Получение GET-параметров из url
     *
     * @returns {any}
     */
    const getUrlParams = function () {
        // извлекаем строку из объекта window
        let queryString = window.location.search.slice(1);

        // объект для хранения параметров
        let obj = {};

        // если есть строка запроса
        if (queryString) {
            // данные после знака # будут опущены
            queryString = queryString.split('#')[0];

            // разделяем параметры
            let arr = queryString.split('&');

            for (let i = 0; i < arr.length; i++) {
                // разделяем параметр на ключ => значение
                let a = arr[i].split('=');

                // обработка данных вида: list[]=thing1&list[]=thing2
                let paramNum = undefined;
                let paramName = a[0].replace(/\[\d*\]/, function (v) {
                    paramNum = v.slice(1, -1);
                    return '';
                });

                // передача значения параметра ('true' если значение не задано)
                let paramValue = (typeof (a[1]) === 'undefined') ? true : a[1];

                // если ключ параметра уже задан
                if (obj[paramName]) {
                    // преобразуем текущее значение в массив
                    if (typeof obj[paramName] === 'string') {
                        obj[paramName] = [obj[paramName]];
                    }

                    if (typeof paramNum === 'undefined') {
                        obj[paramName].push(paramValue);
                    } else {
                        obj[paramName][paramNum] = paramValue;
                    }
                } else {
                    // если параметр не задан, делаем это вручную
                    obj[paramName] = paramValue;
                }
            }
        }

        return obj;
    };

    /**
     * Установка GET-параметров в url
     */
    const setUrlParams = function (paramsObject) {
        let paramsArray = [];

        for (let param in paramsObject) {
            paramsArray.push([param, paramsObject[param]]);
        }

        let pageUrl = window.location.href.split('?')[0];
        let paramsString = paramsArray.map(el => `${el[0]}=${el[1]}`).join('&');

        window.history.pushState({
            html: $wrapper.html(),
            pageTitle: document.title
        }, '', `${pageUrl}?${paramsString}`);
    };

    /**
     * Получение списка запрашиваемых сущностей
     *
     * @param {Object} requestParams
     */
    const getEntities = function (requestParams) {
        let params = $.extend({}, defaultParams, requestParams);

        $loader.addClass('loading');
        $wrapper.empty();

        $.ajax({
            url: ajaxUrl,
            data: params
        }).done(function (result) {
            $loader.removeClass('loading');

            setUrlParams(requestParams);

            $wrapper.html(result);
            $wrapper.find('.pagination a').each(function () {
                let $link = $(this);
                let urlWithoutAjax = '?' + $link.attr('href').split('?')[1].replace(/AJAX=true&?/, '');
                $link.attr('href', urlWithoutAjax);
            });
        }).fail(function (err) {
            console.log('Не удалось загрузить список сущностей', err);
        });
    };

    /**
     * Добавляем выбор месяца/года
     */
    const initMonthSelect = function () {
        let $filterMonth = $('<select>', {
            class: 'js-select2 calendar-filter-month',
            attr: {
                'data-select2-class': 'select2-filter-month'
            },
            append: function () {
                let monthArray = [
                        'Январь',
                        'Февраль',
                        'Март',
                        'Апрель',
                        'Май',
                        'Июнь',
                        'Июль',
                        'Август',
                        'Сентябрь',
                        'Октябрь',
                        'Ноябрь',
                        'Декабрь'
                ];

                if (lang === 'en') {
                    monthArray = [
                        'January',
                        'February',
                        'March',
                        'April',
                        'May',
                        'June',
                        'July',
                        'August',
                        'September',
                        'October',
                        'November',
                        'December'
                    ];
                }

                return monthArray.map(function (el, index) {
                    return $('<option>', {
                        value: index,
                        text: el,
                        selected: index === maxDate.getMonth()
                    });
                });
            }
        });

        let $filterYear = $('<select>', {
            class: 'js-select2 calendar-filter-year',
            attr: {
                'data-select2-class': 'select2-filter-year'
            },
            append: function () {
                let minYear = minDate.getFullYear();
                let maxYear = maxDate.getFullYear();
                let optionsArray = [];

                for (let i = minYear; i <= maxYear; i++) {
                    optionsArray.push($('<option>', {
                        value: i,
                        text: i,
                        selected: i === maxDate.getFullYear()
                    }));
                }

                return optionsArray;
            }
        });

        let $closeBtn = $('<button>', {
            class: 'js-hide-calendar calendar-close-btn',
            type: 'button'
        });

        $self.prepend($('<div>', {
            class: 'calendar-filter js-calendar-filter',
            append: [
                $filterMonth,
                $filterYear,
                $closeBtn
            ]
        }));

        // Инициализация select2 для полей выбора года/месяца
        $('.js-calendar-filter .js-select2').each(function () {
            let $select = $(this);

            $select.select2({
                width: 'style',
                dropdownParent: $select.parent(),
                containerCssClass: $select.data('select2-class')
            });

            $select.on('change', function () {
                let datepicker = $self.data('datepicker');
                let selectedYear = parseInt($('.js-select2.calendar-filter-year').val());
                let selectedMonth = (parseInt($('.js-select2.calendar-filter-month').val()) + 1).toString().padStart(2, '0');

                if (typeof datepicker !== 'undefined') {
                    datepicker.date = new Date(`${selectedYear}-${selectedMonth}-01`);
                }

                getEntities({
                    'YEAR': selectedYear,
                    'MONTH': selectedMonth
                });
            });

            // Если подключен PerfectScrollbar - подключаем кастомный скролл в выпадающих списках
            if (typeof PerfectScrollbar === 'undefined') {
                return;
            }

            $select.on('select2:open', function () {
                $('.select2-results__options').each(function (index, el) {
                    if (typeof $(el).data('ps') === 'undefined') {
                        $(el).data('ps', new PerfectScrollbar(el, {
                            suppressScrollX: true
                        }));
                    }
                    setTimeout(function () {
                        $(el).data('ps').update();
                    }, 100);
                });
            });
        });

        // Страница не должна скроллиться, пока скроллится список опций
        $(document).on('wheel', '.select2-results__options', function (e) {
            e.preventDefault();
        });
    };

    /**
     * Инициализация
     */
    const init = function () {
        if (typeof $.fn.select2 !== 'undefined') {
            initMonthSelect();
        }
        // Инициализация датапикера
        $self.datepicker({
            inline: true,
            minDate: minDate,
            maxDate: maxDate, // нельзя читать из будущего - у одних ребят была куча проблем из-за этого в 1985 году
            startDate: maxDate,
            toggleSelected: false,
            selectOtherMonths: false,
            onRenderCell: function (date, cellType) {
                // форматирование ячеек календаря
                let datesArray = $self.data('dates');
                let dateDayString = date.getDate().toString().padStart(2, '0');
                let dateMonthString = (date.getMonth() + 1).toString().padStart(2, '0');
                let dateText = `${date.getFullYear()}-${dateMonthString}-${dateDayString}`;

                if (typeof datesArray !== 'undefined' && cellType === 'day') {
                    if (datesArray.indexOf(dateText) !== -1) {
                        return {
                            classes: '-has-event-'
                        };
                    } else {
                        return {
                            disabled: true
                        };
                    }
                }
            },
            onSelect: function (formattedDate, date) {
                // обработка выбора конкретной даты в календаре
                getEntities({
                    YEAR: date.getFullYear(),
                    MONTH: (date.getMonth() + 1),
                    DAY: date.getDate(),
                });
            }
        });

        let urlParams = getUrlParams();
        if (Object.keys(urlParams).length) {
            getEntities(urlParams);
        }
    };

    init();
};
